export default __webpack_public_path__ + "static/media/trr-drink-juicecocktail-strawbantini.4dd29e61.png";